import React, { useEffect } from "react";
import { gsap } from "gsap";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
gsap.registerPlugin(MorphSVGPlugin);

const One = () => {
  useEffect(() => {
    gsap.set("#ring-one-path", { autoAlpha: 0 });
    gsap.set("#ring-one-text", {
      autoAlpha: 0,
      scale: 0,
      transformOrigin: "center center",
    });
    gsap.set("#ring1-circ-before", {
      scale: 0,
      transformOrigin: "center center",
    });
    gsap.to("#int1", { y: 10, yoyo: true, repeat: -1 });
  }, []);

  const drawRing = () => {
    gsap.to(".ring-before", { duration: 1, morphSVG: ".ring-after" });
    gsap.to("#ring-one-text", {
      autoAlpha: 1,
      duration: 1,
      scale: 0.8,
      transformOrigin: "center center",
      delay: 0.3,
    });
  };

  const hoverRing = () => {
    // gsap.to('#ring1-circ-before',{fill: '#fff',scale: 1,transformOrigin: 'center center'})
    gsap.to(".ring-before", { duration: 1, morphSVG: ".ring-after" });
    gsap.to("#ring-one-text", {
      autoAlpha: 1,
      duration: 1,
      scale: 0.8,
      transformOrigin: "center center",
      delay: 0.3,
    });
  };

  const leaveRing = () => {
    gsap.to("#ring1-circ-before", {
      fill: "#000",
      scale: 0,
      transformOrigin: "center center",
    });
  };

  return (
    <svg
      id="int1"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 255.4 255.4"
      style={{ enableBackground: "new 0 0 255.4 255.4" }}
      onMouseEnter={hoverRing}
      onMouseLeave={leaveRing}
    >
      <g id="Layer_1">
        <g>
          <g>
            <path
              className="ring-before"
              id="ring1-circ-before"
              style={{ fill: "#000" }}
              d="M127.7,10c31.4,0,61,12.2,83.2,34.5c22.2,22.2,34.5,51.8,34.5,83.2s-12.2,61-34.5,83.2
				c-22.2,22.2-51.8,34.5-83.2,34.5s-61-12.2-83.2-34.5C22.2,188.7,10,159.1,10,127.7s12.2-61,34.5-83.2C66.7,22.2,96.3,10,127.7,10
				 M127.7,0C57.2,0,0,57.2,0,127.7s57.2,127.7,127.7,127.7s127.7-57.2,127.7-127.7S198.2,0,127.7,0L127.7,0z"
            />
          </g>
          <g>
            <path
              className="ring-before"
              style={{ fill: "#F6B74B" }}
              d="M138.9,179h-19.5v-75.1l-24.2,9.8V94l43.6-17.6V179z"
            />
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                className="ring-after"
                id="ring-one-path"
                style={{ fill: "#F6B74B" }}
                d="M127.7,10c31.4,0,61,12.2,83.2,34.5c22.2,22.2,34.5,51.8,34.5,83.2s-12.2,61-34.5,83.2
					c-22.2,22.2-51.8,34.5-83.2,34.5s-61-12.2-83.2-34.5C22.2,188.7,10,159.1,10,127.7s12.2-61,34.5-83.2
					C66.7,22.2,96.3,10,127.7,10 M127.7,0C57.2,0,0,57.2,0,127.7s57.2,127.7,127.7,127.7s127.7-57.2,127.7-127.7S198.2,0,127.7,0
					L127.7,0z"
              />
            </g>
          </g>
          <path
            className="ring-after"
            id="ring-one-text"
            style={{ fill: "#FFFFFF" }}
            d="M57.6,80.1h-4.5V57.7h4.5V80.1z M77,70.3v9.9h-4.2v-8.5c0-2.2-1.1-3.5-3-3.5
			c-1.8,0-3.3,1.2-3.3,3.5v8.5h-4.2V64.6h4.1v1.8c1.1-1.6,2.8-2.2,4.6-2.2C74.4,64.2,77,66.7,77,70.3z M94.7,67.1l-3,2.5
			c-0.9-1-2-1.6-3.3-1.6c-2.2,0-3.9,1.7-3.9,4.3c0,2.6,1.7,4.3,3.9,4.3c1.3,0,2.5-0.6,3.4-1.6l3,2.5c-1.5,1.9-3.6,2.9-6.2,2.9
			c-4.9,0-8.3-3.5-8.3-8.2c0-4.7,3.3-8.2,8.3-8.2C91.1,64.2,93.3,65.3,94.7,67.1z M108.3,64.6l-0.6,4.1c-0.7-0.3-1.7-0.5-2.5-0.5
			c-1.9,0-3.3,1.2-3.3,3.5v8.5h-4.2V64.6h4v1.7c1-1.5,2.5-2.1,4.4-2.1C107.1,64.2,107.8,64.3,108.3,64.6z M125.1,72.4
			c0,0.5,0,1.1-0.1,1.4h-11c0.4,2.2,2,3.2,4,3.2c1.3,0,2.8-0.5,3.9-1.5l2.4,2.7c-1.8,1.6-4,2.4-6.6,2.4c-4.8,0-8.1-3.2-8.1-8.1
			s3.2-8.2,7.8-8.2C122,64.2,125.1,67.5,125.1,72.4z M114,70.9h6.9c-0.4-2-1.6-3.1-3.4-3.1C115.5,67.8,114.4,69,114,70.9z
			 M143.7,80.1h-4.1v-1.7c-1,1.2-2.5,2.1-4.6,2.1c-4.3,0-7.5-3.5-7.5-8.2c0-4.7,3.2-8.2,7.5-8.2c2.1,0,3.6,0.9,4.6,2.1v-1.7h4.1
			V80.1z M131.8,72.4c0,2.4,1.6,4.3,4,4.3c2.4,0,4-1.8,4-4.3c0-2.4-1.6-4.3-4-4.3C133.3,68.1,131.8,70,131.8,72.4z M159.2,69
			c-1.2-0.6-3.2-1.2-4.9-1.3c-1.6,0-2.4,0.6-2.4,1.4c0,0.9,1.1,1.1,2.5,1.3l1.4,0.2c3.4,0.5,5.2,2,5.2,4.6c0,3.2-2.6,5.3-7.1,5.3
			c-2.1,0-4.9-0.4-6.9-1.8l1.6-3.2c1.3,0.9,2.9,1.5,5.3,1.5c1.9,0,2.9-0.5,2.9-1.5c0-0.8-0.8-1.2-2.6-1.4L153,74
			c-3.6-0.5-5.4-2.1-5.4-4.7c0-3.2,2.5-5.1,6.5-5.1c2.5,0,4.4,0.5,6.5,1.5L159.2,69z M178.7,72.4c0,0.5,0,1.1-0.1,1.4h-11
			c0.4,2.2,2,3.2,4,3.2c1.3,0,2.8-0.5,3.9-1.5l2.4,2.7c-1.8,1.6-4,2.4-6.6,2.4c-4.8,0-8.1-3.2-8.1-8.1s3.2-8.2,7.8-8.2
			C175.6,64.2,178.7,67.5,178.7,72.4z M167.7,70.9h6.9c-0.4-2-1.6-3.1-3.4-3.1C169.2,67.8,168,69,167.7,70.9z M193.2,66.2v-9.2h4.2
			v23h-4.1v-1.7c-1,1.2-2.5,2.1-4.6,2.1c-4.3,0-7.5-3.5-7.5-8.2c0-4.7,3.2-8.2,7.5-8.2C190.7,64.2,192.2,65,193.2,66.2z M185.4,72.4
			c0,2.4,1.6,4.3,4,4.3c2.4,0,4-1.8,4-4.3c0-2.4-1.6-4.3-4-4.3C187,68.1,185.4,70,185.4,72.4z M84,110.8c0,0.5,0,1.1-0.1,1.4h-11
			c0.4,2.2,2,3.2,4,3.2c1.3,0,2.8-0.5,3.9-1.5l2.4,2.7c-1.8,1.6-4,2.4-6.6,2.4c-4.8,0-8.1-3.2-8.1-8.1s3.2-8.2,7.8-8.2
			C80.9,102.6,84,105.9,84,110.8z M72.9,109.3h6.9c-0.4-2-1.6-3.1-3.4-3.1C74.5,106.2,73.3,107.4,72.9,109.3z M102.1,108.7v9.9h-4.2
			V110c0-2.2-1.1-3.5-3-3.5c-1.8,0-3.3,1.2-3.3,3.5v8.5h-4.2V103h4.1v1.8c1.1-1.6,2.8-2.2,4.6-2.2
			C99.6,102.6,102.1,105.1,102.1,108.7z M117.5,104.7V103h4.1v21.9h-4.2v-8c-1,1.2-2.5,2-4.6,2c-4.3,0-7.5-3.5-7.5-8.2
			c0-4.7,3.2-8.2,7.5-8.2C115,102.6,116.5,103.5,117.5,104.7z M109.6,110.8c0,2.4,1.6,4.3,4,4.3c2.4,0,4-1.8,4-4.3
			c0-2.4-1.6-4.3-4-4.3C111.2,106.5,109.6,108.4,109.6,110.8z M140.5,111.9c0,4.9-3.5,7-7.3,7c-3.9,0-7.3-2.1-7.3-7V103h4.2v8.5
			c0,2.5,1.4,3.5,3.2,3.5c1.8,0,3.2-1,3.2-3.5V103h4.2V111.9z M149.5,98c0,1.5-1.2,2.7-2.7,2.7c-1.5,0-2.7-1.2-2.7-2.7
			c0-1.5,1.2-2.7,2.7-2.7C148.3,95.3,149.5,96.5,149.5,98z M148.9,118.5h-4.2V103h4.2V118.5z M163.9,103l-0.6,4.1
			c-0.7-0.3-1.7-0.5-2.5-0.5c-1.9,0-3.3,1.2-3.3,3.5v8.5h-4.2V103h4v1.7c1-1.5,2.5-2.1,4.4-2.1C162.6,102.6,163.4,102.7,163.9,103z
			 M171.3,125h-4.6l5.4-9.8l-6.7-12.2h4.7l4.3,8l4.1-8h4.6L171.3,125z M57,156.9h-4.8l-6.1-15.5h4.5l4,11.1l4-11.1h4.4L57,156.9z
			 M81,149.2c0,4.7-3.6,8.2-8.4,8.2c-4.8,0-8.4-3.5-8.4-8.2c0-4.7,3.6-8.2,8.4-8.2C77.4,141,81,144.5,81,149.2z M68.4,149.2
			c0,2.5,1.8,4.3,4.1,4.3s4.1-1.8,4.1-4.3c0-2.5-1.8-4.3-4.1-4.3S68.4,146.7,68.4,149.2z M88.5,156.9h-4.2v-23h4.2V156.9z
			 M107.5,150.3c0,4.9-3.5,7-7.3,7c-3.9,0-7.3-2.1-7.3-7v-8.9H97v8.5c0,2.5,1.4,3.5,3.2,3.5c1.8,0,3.2-1,3.2-3.5v-8.5h4.2V150.3z
			 M136.8,147.1v9.9h-4.2v-8.5c0-2.2-1.1-3.5-3-3.5c-1.8,0-3.3,1.2-3.3,3.5v8.5h-4.2v-8.5c0-2.2-1.1-3.5-3-3.5
			c-1.8,0-3.3,1.2-3.3,3.5v8.5h-4.2v-15.5h4.1v1.8c1.1-1.6,2.8-2.2,4.6-2.2c2.2,0,4.1,1,5.1,2.7c1.2-2,3.2-2.7,5.3-2.7
			C134.4,141,136.8,143.5,136.8,147.1z M155.5,149.2c0,0.5,0,1.1-0.1,1.4h-11c0.4,2.2,2,3.2,4,3.2c1.3,0,2.8-0.5,3.9-1.5l2.4,2.7
			c-1.8,1.6-4,2.4-6.6,2.4c-4.8,0-8.1-3.2-8.1-8.1s3.2-8.2,7.8-8.2C152.4,141,155.5,144.3,155.5,149.2z M144.5,147.7h6.9
			c-0.4-2-1.6-3.1-3.4-3.1C146,144.6,144.8,145.8,144.5,147.7z M169.9,145.8c-1.2-0.6-3.2-1.2-4.9-1.3c-1.6,0-2.4,0.6-2.4,1.4
			c0,0.9,1.1,1.1,2.5,1.3l1.4,0.2c3.4,0.5,5.2,2,5.2,4.6c0,3.2-2.6,5.3-7.1,5.3c-2.1,0-4.9-0.4-6.9-1.8l1.6-3.2
			c1.3,0.9,2.9,1.5,5.3,1.5c1.9,0,2.9-0.5,2.9-1.5c0-0.8-0.8-1.2-2.6-1.4l-1.3-0.2c-3.6-0.5-5.4-2.1-5.4-4.7c0-3.2,2.5-5.1,6.5-5.1
			c2.5,0,4.4,0.5,6.5,1.5L169.9,145.8z M198.2,156.9l-2.4-2.3c-1.6,1.5-3.7,2.7-6.6,2.7c-4.4,0-7-2.3-7-6c0-2.6,1.8-4.6,3.9-6.1
			c-1.9-1.9-2.8-3.3-2.8-5.5c0-3.2,2.6-5.6,6.6-5.6c3.9,0,6.5,2.2,6.5,5.5c0,2.4-2,4.2-4.2,5.8l3.5,3.4l3.2-4.5l3.2,2.2l-3.6,5
			l5.6,5.4H198.2z M193.1,152l-4.3-4.1c-1.2,1-2.1,2-2.1,3.2c0,1.5,1.2,2.5,2.9,2.5C190.9,153.5,192,153,193.1,152z M189.5,142.9
			c1.5-1.1,2.6-2,2.6-3.1c0-1.2-0.8-1.9-2.3-1.9c-1.4,0-2.3,0.8-2.3,2C187.5,140.8,188,141.4,189.5,142.9z M60.5,182.3l-3,2.5
			c-0.9-1-2-1.6-3.3-1.6c-2.2,0-3.9,1.7-3.9,4.3c0,2.6,1.7,4.3,3.9,4.3c1.3,0,2.5-0.6,3.4-1.6l3,2.5c-1.5,1.9-3.6,2.9-6.2,2.9
			c-4.9,0-8.3-3.5-8.3-8.2c0-4.7,3.3-8.2,8.3-8.2C56.9,179.4,59.1,180.5,60.5,182.3z M79,187.6c0,4.7-3.6,8.2-8.4,8.2
			c-4.8,0-8.4-3.5-8.4-8.2c0-4.7,3.6-8.2,8.4-8.2C75.4,179.4,79,182.9,79,187.6z M66.5,187.6c0,2.5,1.8,4.3,4.1,4.3s4.1-1.8,4.1-4.3
			c0-2.5-1.8-4.3-4.1-4.3S66.5,185.1,66.5,187.6z M107.6,185.5v9.9h-4.2v-8.5c0-2.2-1.1-3.5-3-3.5c-1.8,0-3.3,1.2-3.3,3.5v8.5h-4.2
			v-8.5c0-2.2-1.1-3.5-3-3.5c-1.8,0-3.3,1.2-3.3,3.5v8.5h-4.2v-15.5h4.1v1.8c1.1-1.6,2.8-2.2,4.6-2.2c2.2,0,4.1,1,5.1,2.7
			c1.2-2,3.2-2.7,5.3-2.7C105.1,179.4,107.6,181.9,107.6,185.5z M128,187.6c0,4.7-3.2,8.2-7.5,8.2c-2.1,0-3.6-0.8-4.6-2v8h-4.2
			v-21.9h4.1v1.7c1-1.3,2.5-2.1,4.6-2.1C124.8,179.4,128,182.9,128,187.6z M115.7,187.6c0,2.4,1.6,4.3,4,4.3c2.5,0,4-1.9,4-4.3
			c0-2.4-1.5-4.3-4-4.3C117.4,183.3,115.7,185.1,115.7,187.6z M135.6,195.3h-4.2v-23h4.2V195.3z M154.4,187.6c0,0.5,0,1.1-0.1,1.4
			h-11c0.4,2.2,2,3.2,4,3.2c1.3,0,2.8-0.5,3.9-1.5l2.4,2.7c-1.8,1.6-4,2.4-6.6,2.4c-4.8,0-8.1-3.2-8.1-8.1s3.2-8.2,7.8-8.2
			C151.3,179.4,154.4,182.7,154.4,187.6z M143.3,186.1h6.9c-0.4-2-1.6-3.1-3.4-3.1C144.9,183,143.7,184.2,143.3,186.1z M166.2,187.5
			l5.7,7.9h-5l-3.5-4.9l-3.4,4.9h-4.8l5.7-7.9l-5.6-7.6h5l3.3,4.8l3.3-4.8h4.8L166.2,187.5z M179.2,174.8c0,1.5-1.2,2.7-2.7,2.7
			c-1.5,0-2.7-1.2-2.7-2.7c0-1.5,1.2-2.7,2.7-2.7C178,172.1,179.2,173.3,179.2,174.8z M178.6,195.3h-4.2v-15.5h4.2V195.3z
			 M194.2,183.5h-5.6v5.7c0,1.9,1,2.6,2.3,2.6c1,0,2.1-0.5,2.9-1l1.5,3.3c-1.4,0.9-2.9,1.6-5.1,1.6c-3.8,0-5.8-2.2-5.8-6.2v-6h-3
			v-3.7h3v-4.6h4.2v4.6h5.6V183.5z M201.8,201.8h-4.6l5.4-9.8l-6.7-12.2h4.7l4.3,8l4.1-8h4.6L201.8,201.8z"
          />
        </g>
      </g>
      <g id="Layer_2"></g>
    </svg>
  );
};

export default One;
